<template>
  <div>
    <section class="bg-yellow" style="padding: 40px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center div-header2">
            <h1>Proavian Broiler Feed</h1>
            <div class="subheader">
              <p class="font18">Feedpro's answer to your broiler chicken feed needs. Completely natural – zero antibiotics.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section style="padding: 40px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-9 col-md-12 col-sm-12 div-subheader div-right feedpro-flex" style="height: auto; padding-right: 40px;">
            <div>
              <h2 class="text-black">The Natural Choice</h2>
              <p>
                Just like Feedpro hog feeds, Proavian contains only highly-digestible plant-based protein, natural growth promotants, vitamins, and minerals. It does not contain any mammalian or avian ingredients and by-products and is free from
                harmful chemicals and residues.
              </p>
              <h2 class="padtop5 text-black">Probiotics-based</h2>
              <p class="mobile-space">Probiotics are also used to promote a healthy gut, which in turn improves digestion and immunity. Proavian does not contain any antibiotics, which when ingested by humans, can contribute to antibiotic resistance.</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-12 col-sm-12 div-image2 text-center div-flex">
            <div style="margin: 0 auto">
              <img :src="`${state.root_url}/images/proavian-1.png`" class="img-proavian" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bg-yellow row-panel4">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-12 col-sm-12 div-image">
            <img :src="`${state.root_url}/images/proavian-2.png`" class="img-bwa" />
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader div-header2 feedpro-flex" style="height: auto; padding-left: 40px;">
            <div>
              <h2>Optimum Growth Performance</h2>
              <p class="text-black">
                Proavian contains the right levels of digestible energy and proteins. It includes the right amount of vitamins and minerals to improve resistance from sickness. It also features multi-enzymes and specific amounts of amino acids to
                allow for chicken to maximize the absorption of nutrients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader reverse-div2 margbottom-35">
            <div>
              <h2 class="text-black">Feed for Every Growth Stage</h2>
              <p>Poultry need different levels of protein, energy, and nutrition at different stages or weights. Feedpro has specific products that suit each growth stage.</p>
              <p class="btn-paragraph"><a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Proavian_Brochure.pdf" class="button-warning" target="_blank">VIEW PROAVIAN FEED GUIDE</a></p>
            </div>
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12 div-image reverse-image2">
            <img :src="`${state.root_url}/images/proavian-3.png`" class="img-bwa" />
          </div>
          <div class="col-lg-5 col-md-12 col-sm-12 div-image img-align reverse-image">
            <img :src="`${state.root_url}/images/proavian-3.png`" class="img-bwa" />
          </div>
          <div class="col-lg-7 col-md-12 col-sm-12 div-subheader reverse-div">
            <h2 class="text-black">Feed for Every Growth Stage</h2>
            <p>Poultry need different levels of protein, energy, and nutrition at different stages or weights. Feedpro has specific products that suit each growth stage.</p>
            <p class="btn-paragraph padtop5">
              <a href="https://pronatural-storage.s3.ap-southeast-1.amazonaws.com/feedpro/downloadable/Proavian_Brochure.pdf" class="button-warning" target="_blank">VIEW PROAVIAN FEED GUIDE</a>
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-video div-panel-2">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-12 div-subheader feedpro-flex" style="height: auto;">
            <div>
              <h2 class="text-black">FeedproTV Feature</h2>
              <h4 class="roboto400">Proavian Feeds</h4>
              <p>Introducing Proavian Feeds – natural broiler feeds. Proavian contains zero antibiotics, ensuring you of safe and healthy chicken meat. Using Proavian also lessens flies and removes the foul smell of your poultry farm.</p>
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 div-youtube">
            <iframe 
              width="100%" 
              height="280" 
              src="https://www.youtube.com/embed/Y6tzm83jVMk" 
              frameborder="0" 
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
              allowfullscreen="">
            </iframe>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { reactive } from 'vue';

export default {
  setup() {
    const state = reactive({
      root_url: process.env.VUE_APP_ENDPOINT
    });

    return {
      state
    }
  }
}
</script>